import { render, staticRenderFns } from "./Pricing.vue?vue&type=template&id=0c001b21&"
import script from "./Pricing.vue?vue&type=script&lang=js&"
export * from "./Pricing.vue?vue&type=script&lang=js&"
import style0 from "./Pricing.vue?vue&type=style&index=0&id=0c001b21&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports